import axios, { AxiosInstance } from 'axios';
import { clearAuth, getToken } from '@core/utils/authBridge';
import { readTenantSession } from '@core/utils/tenantSession';

const API_BASE_URL = import.meta.env.VITE_API_URL;

const axiosInstance: AxiosInstance = axios.create({
  baseURL: `${API_BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const tenant = readTenantSession();
    if (tenant?.id != null) {
      config.headers['X-Tenant-Id'] = String(tenant.id);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const method = error.config?.method?.toUpperCase();
    const endpoint = error.config?.url;
    console.error(`Request ${method} ${endpoint} failed`, error);
    if (error.response?.status === 401) {
      clearAuth();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
